export default {"src":"/stays/_next/static/media/ValueForMoney.3e8fdcb6.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};